import { handleResponse } from './handle-response'
import { apiRoute, AUTH_V2 } from './api-route'

let isRefreshing = false
let failedRequestsQueue = []

const _allowedApiBase = apiRoute()

function validateUrl (url) {
  if (typeof url === 'string' && url.startsWith('/')) return
  if (_allowedApiBase && typeof url === 'string' && url.startsWith(_allowedApiBase)) return
  throw new Error('SSRF protection: request to disallowed URL blocked')
}

function processQueue (error, token = null) {
  failedRequestsQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedRequestsQueue = []
}

function customFetch (url, options) {
  validateUrl(url)
  return fetch(url, options)
    .then(handleResponse)
    .catch(async error => {
      const isUnauthorized = error === 'Unauthorized' ||
                             // error === 'Not authenticated' ||
                             (error && (error.message === 'Unauthorized' || error.message === 'Not authenticated'))

      if (isUnauthorized) {
        // Prevent infinite loop if login or refresh itself fails
        if (url.includes('/login') || url.includes('/refresh')) {
          return Promise.reject(error)
        }

        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedRequestsQueue.push({ resolve, reject })
          })
            .then(() => {
              return customFetch(url, options)
            })
            .catch(err => {
              return Promise.reject(err)
            })
        }

        isRefreshing = true

        try {
          const refreshUrl = apiRoute() + AUTH_V2 + '/refresh'
          // We must use standard fetch for the refresh call itself to avoid recursion overhead or sticking to wrapper if we wanted,
          // but we specifically need to NOT using customFetch for this, and handleResponse is fine.
          await fetch(refreshUrl, { method: 'POST', credentials: 'include' }).then(handleResponse)

          isRefreshing = false
          processQueue(null, true)
          // Retry the original request
          return customFetch(url, options)
        } catch (err) {
          isRefreshing = false
          processQueue(err, null)
          // If refresh fails, redirect to login
          // using window.location because router might not be available or circular dep issues if imported from helpers/index
          window.location.href = '/login'
          return Promise.reject(err)
        }
      }

      return Promise.reject(error)
    })
}

export const fetchWrapper = {
  get,
  post,
  put,
  delete: _delete
}

function get (url, headers = {}) {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: headers
  }
  return customFetch(url, requestOptions)
}

function post (url, body, headers = {}) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    credentials: 'include',
    body: JSON.stringify(body)
  }
  return customFetch(url, requestOptions)
}

function put (url, body, headers = {}) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...headers },
    credentials: 'include',
    body: JSON.stringify(body)
  }
  return customFetch(url, requestOptions)
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete (url, body = null, headers = {}) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...headers }
  }
  if (body) {
    requestOptions.body = JSON.stringify(body)
  }
  return customFetch(url, requestOptions)
}
